import type { FC } from 'react';
import CurrencySelectorInput from '../CurrencySelectorInput';
import ComponentWrapper from '../NestedMenu/ComponentWrapper';

const CurrencySelectorNavItem: FC = () => (
  <ComponentWrapper>
    <CurrencySelectorInput
      location="nestedMenu"
      variant="withFlag"
    />
  </ComponentWrapper>
);

export default CurrencySelectorNavItem;
